import React from "react";

function FoodItem({
  imageSrc,
  rating,
  price,
  name,
  description,
  discount,
  onOrder,
}) {
  console.log("🚀 ~ FoodItem ~ price:", price);
  console.log("🚀 ~ FoodItem ~ discount:", discount);
  const discountAmount = (price * discount) / 100;

  const finalPrice = (price - (discountAmount || 0)).toFixed(2);
  const truncateText = (text, maxLength) => {
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };

  return (
    <article
      className="flex flex-col md:w-[300px] md:h-[460px] w-[200px] h-[330px]  items-center max-w-[300px] max-h-[500px]"
      style={{
        background:
          "linear-gradient(180deg, rgba(255, 255, 255, 0) 50%, rgba(245, 71, 72, 0.3) 100%)",
        borderRadius: "25px",
        // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        transition: "background 0.5s ease",
        overflow: "hidden",
        // width: "300px", // Fixed width for all cards
        // height: "400px", // Fixed height for all cards
      }}
    >
      <div className="flex flex-col items-center px-4 pt-5 pb-2.5  relative">
        <div
          className="relative w-[150px] h-[150px] md:w-[200px] md:h-[200px] rounded-full overflow-hidden"
          style={{
            borderTop: "16px solid rgba(245, 71, 72, 0.3)",
            padding: "14px",
          }}
        >
          <img
            loading="lazy"
            src={imageSrc}
            alt={name}
            className="object-cover w-full h-full rounded-full"
          />
        </div>

        <div className="flex justify-center items-center absolute bottom-[10px] right-7 md:bottom-[15px] md:right-9 z-10 w-[40px] h-[40px] md:w-[57px] md:h-[57px] bg-yellow-400 rounded-full border-4 border-white">
          <span className="text-white text-xs md:text-sm">{discount}%</span>
        </div>
      </div>

      <h2 className="mt-3 text-base md:text-lg font-semibold text-center text-[#F54748] capitalize">
        {name}
      </h2>

      <p
        className="mt-2 md:mt-3 text-[10px] md:text-[11.2px] text-center opacity-80 text-[#191919] max-w-[80%] md:max-w-[60%] overflow-hidden"
        style={{ maxHeight: "40px" }}
      >
        {truncateText(description, 60)}
      </p>
      <div className="py-2 flex items-center  justify-between">
        <div className="flex justify-center items-center">
          <h5 className={`md:text-lg text-[14px] text-[#C97C2A] font-[700] flex items-center`}> £{finalPrice}</h5>
          <h4 className={` flex text-[16px] text-[#d55b45] pl-3 mt-[-4px] line-through`}> £{price}</h4>
        </div>
      </div>
      <button
        onClick={onOrder}
        className="px-2 flex items-center  justify-center py-2 w-[80px] md:w-[91.08px] h-[30px] md:h-[31.29px] mt-5 md:mt-5 text-xs md:text-sm text-[#FFFFFF] bg-[#F54748] rounded-[70px] self-center"
      >
        Order Now
      </button>
    </article>
  );
}

export default FoodItem;
